import mutations from './mutations'
import actions from './actions'
import * as getters from './getters'

const state = {
  notifications: {}
}

export default {
  state,
  mutations,
  actions,
  getters
}
